import { ConfigSelectOption } from 'store/types/SelectOption';
import SubscriptionStatus from 'store/enums/SubscriptionStatus';

const membershipStatusConfig: Record<SubscriptionStatus, ConfigSelectOption> = {
  [SubscriptionStatus.Active]: {
    name: 'Current',
    theme: 'green',
  },
  [SubscriptionStatus.Expired]: {
    name: 'Expired',
    theme: 'red',
  },
  [SubscriptionStatus.NonMember]: {
    name: 'Non-Member',
    theme: 'grey',
  },
  [SubscriptionStatus.Pending]: {
    name: 'Pending',
    theme: 'yellow',
  },
  [SubscriptionStatus.Terminated]: {
    name: 'Terminated',
    theme: 'grey',
  },
  [SubscriptionStatus.Canceled]: {
    name: 'Canceled',
    theme: 'grey',
  },
  [SubscriptionStatus.DoNotRenew]: {
    name: 'Do Not Renew',
    theme: 'yellow',
  },
  [SubscriptionStatus.Suspended]: {
    name: 'Suspended',
    theme: 'red',
  },
  [SubscriptionStatus.Unknown]: {
    name: 'Unknown',
    theme: 'grey',
  },
};

export default membershipStatusConfig;
